module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLogin),
      expression: "isShowLogin"
    }],
    staticClass: "weui-mask"
  }, [_c('div', {
    staticClass: "login-panel",
    attrs: {
      "id": "login_container"
    }
  }, [_c('div', {
    staticClass: "left-right-margin center relative-top-primary"
  }, [_c('img', {
    staticClass: "login-icon",
    attrs: {
      "src": require("../assets/icon_rounded_256.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("登录易退税发现更多")]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell weui-cell_select weui-cell_select-before"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountType),
      expression: "accountType"
    }],
    staticClass: "weui-select",
    attrs: {
      "name": "select2"
    },
    on: {
      "change": function($event) {
        _vm.accountType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "telephone"
    },
    domProps: {
      "value": "telephone"
    }
  }, [_vm._v("手机")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    },
    domProps: {
      "value": "email"
    }
  }, [_vm._v("邮箱")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountType == 'telephone'),
      expression: "accountType == 'telephone'"
    }],
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "weui-select",
    attrs: {
      "id": "select-code",
      "name": "select2"
    },
    on: {
      "change": function($event) {
        _vm.code = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.telCodes), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.value
      }
    }, [_vm._v(_vm._s(entry.text))])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountType == 'telephone'),
      expression: "accountType == 'telephone'"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.telephone),
      expression: "params.telephone"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "number",
      "pattern": "[0-9]*",
      "placeholder": "请输入号码"
    },
    domProps: {
      "value": _vm._s(_vm.params.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.telephone = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountType == 'email'),
      expression: "accountType == 'email'"
    }],
    staticClass: "weui-cell"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.email),
      expression: "params.email"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "email",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": _vm._s(_vm.params.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.password),
      expression: "params.password"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": _vm._s(_vm.params.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "weui-btn weui-btn_primary margin-top-thirdly",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "weui-btn weui-btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("随便逛逛")]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__tips margin-top-secondly"
  }, [_vm._v("-或使用第三方登录-")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-thirdly"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "primary",
    attrs: {
      "href": _vm.WxLoginLink
    }
  }, [_vm._v("\n              微信内登录\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "center margin-top-fourthly"
  }, [_c('a', {
    staticClass: "primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.wxLogin
    }
  }, [_vm._v("微信外扫码登录")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-fourthly"
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-footer footer margin-top-primary"
  }, [_c('p', {
    staticClass: "weui-footer__links"
  }, [_c('a', {
    staticClass: "weui-footer__link",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.terms
    }
  }, [_vm._v("用户协议")]), _vm._v(" "), _c('a', {
    staticClass: "weui-footer__link",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.terms
    }
  }, [_vm._v("隐私政策")])]), _vm._v(" "), _c('p', {
    staticClass: "weui-footer__text"
  }, [_vm._v("Copyright © 2016 小幕（北京）科技有限公司")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("号码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("邮箱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("密码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20025dca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 188
// module chunks = 2